import { styled } from '../../../lib/stitches'

const Button = styled('button', {
  all: 'unset',
  fontFamily: '$dm',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  whiteSpace: 'nowrap',
  height: '25px',
  overflow: 'hidden',
  boxSizing: 'border-box',
  fontWeight: '$regular',
  padding: '0 $10',
  borderRadius: '$6',
  fontSize: '$12',
  lineHeight: '$25',
  transition: 'all 100ms ease-out',

  '&:disabled': { opacity: 0.4 },

  variants: {
    type: {
      secondary: {
        color: '$text__primary',
        background: '$button__secondary',
        '&:hover:enabled': { background: '$button__secondary__hover' },
        '&:active:enabled': { background: '$button__secondary__active' }
      },
      primary: {
        color: '$text__primary',
        background: '$button__primary',
        '&:hover:enabled': { background: '$button__primary__hover' },
        '&:active:enabled': { background: '$button__primary__active' }
      },
      success: {
        color: '$button__success_text',
        background: '$button__success',
        '&:hover:enabled': { background: '$button__success__hover' },
        '&:active:enabled': { background: '$button__success__active' }
      },
      white: {
        color: '$text__primary',
        background: '$gray01',
        '&:hover:enabled': { background: '$gray02' },
        '&:active:enabled': { background: '$gray03' }
      },
      dark: {
        color: '$text_inverted__primary',
        background: '$button__filled',
        '&:hover:enabled': { background: '$button__filled__hover' },
        '&:active:enabled': { background: '$button__filled__active' }
      },
      outlined: {
        color: '$text__primary',
        border: '$button__border 1px solid',
        '&:hover:enabled': { background: '$button__secondary__hover' },
        '&:active:enabled': { background: '$button__secondary__active' }
      },
      'dark-outline': {
        color: '$text_inverted__primary',
        border: '$text_inverted__primary 1px solid',
        '&:hover:enabled': { background: '$text_inverted__primary', color: '$text__primary' },
        '&:active:enabled': { background: '$text_inverted__primary', color: '$text__primary' }
      }
    },
    modalButton: {
      true: {
        minWidth: '115px',
        minHeight: '48px'
      }
    },
    noHover: {
      true: {
        '&:hover:enabled': { background: 'inherit' }
      }
    },
    big: {
      true: {
        borderRadius: '$12',
        height: '32px',
        fontWeight: '$bold',
        padding: '$4 $16'
      }
    },
    rounded: {
      true: {
        borderRadius: '$round'
      }
    },
    square: {
      true: {
        width: '25px',
        height: '25px',
        padding: '0'
      }
    },
    bigSquare: {
      true: {
        width: '32px',
        height: '32px',
        padding: '0'
      }
    }
  },
  defaultVariants: {
    type: 'secondary'
  }
})

export default Button
